import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Errors`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#broken-npm-installation"
        }}>{`Broken npm installation`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#random-errors"
        }}>{`Random errors`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#no-compatible-version-found"
        }}>{`No compatible version found`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#permissions-errors"
        }}>{`Permissions errors`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#error-enoent-stat-cusersuserappdataroamingnpm-on-windows-7"
        }}><inlineCode parentName="a">{`Error: ENOENT, stat 'C:\\Users\\<user>\\AppData\\Roaming\\npm'`}</inlineCode>{` on Windows 7`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#no-space"
        }}>{`No space`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#no-git"
        }}>{`No git`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#running-a-vagrant-box-on-windows-fails-due-to-path-length-issues"
        }}>{`Running a Vagrant box on Windows fails due to path length issues`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#npm-only-uses-git-and-sshgit-urls-for-github-repos-breaking-proxies"
        }}>{`npm only uses `}<inlineCode parentName="a">{`git:`}</inlineCode>{` and `}<inlineCode parentName="a">{`ssh+git:`}</inlineCode>{` URLs for GitHub repos, breaking proxies`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#ssl-error"
        }}>{`SSL error`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#ssl-intercepting-proxy"
        }}>{`SSL-intercepting proxy`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#not-found--server-error"
        }}>{`Not found / Server error`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#invalid-json"
        }}>{`Invalid JSON`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#many-enoent--enotempty-errors-in-output"
        }}>{`Many `}<inlineCode parentName="a">{`ENOENT`}</inlineCode>{` / `}<inlineCode parentName="a">{`ENOTEMPTY`}</inlineCode>{` errors in output`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#cb-never-called-when-using-shrinkwrapped-dependencies"
        }}><inlineCode parentName="a">{`cb() never called!`}</inlineCode>{` when using shrinkwrapped dependencies`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#npm-login-errors"
        }}>{`npm login errors`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#npm-hangs-on-windows-at-addremotetarball"
        }}><inlineCode parentName="a">{`npm`}</inlineCode>{` hangs on Windows at `}<inlineCode parentName="a">{`addRemoteTarball`}</inlineCode></a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#npm-not-running-the-latest-version-on-a-windows-machine"
        }}>{`npm not running the latest version on a Windows machine`}</a></li>
    </ul>
    <h2>{`Broken npm installation`}</h2>
    <p>{`If your npm is broken:`}</p>
    <ul>
      <li parentName="ul">{`On Mac or Linux, `}<a parentName="li" {...{
          "href": "https://docs.npmjs.com/downloading-and-installing-node-js-and-npm"
        }}>{`reinstall npm`}</a>{`.`}</li>
      <li parentName="ul">{`Windows: If you're on Windows and you have a broken installation, the easiest thing to do is to reinstall node from the official installer (see `}<a parentName="li" {...{
          "href": "try-the-latest-stable-version-of-npm#upgrading-on-windows"
        }}>{`this note about installing the latest stable version`}</a>{`).`}</li>
    </ul>
    <h2>{`Random errors`}</h2>
    <ul>
      <li parentName="ul">{`Some strange issues can be resolved by simply running `}<inlineCode parentName="li">{`npm cache clean`}</inlineCode>{` and trying again.`}</li>
      <li parentName="ul">{`If you are having trouble with `}<inlineCode parentName="li">{`npm install`}</inlineCode>{`, use the `}<inlineCode parentName="li">{`-verbose`}</inlineCode>{` option to see more details.`}</li>
    </ul>
    <h2>{`No compatible version found`}</h2>
    <p>{`You have an outdated npm. `}<a parentName="p" {...{
        "href": "try-the-latest-stable-version-of-npm"
      }}>{`Please update to the latest stable npm`}</a>{`.`}</p>
    <h2>{`Permissions errors`}</h2>
    <p>{`Please see the discussions in "`}<a parentName="p" {...{
        "href": "downloading-and-installing-node-js-and-npm"
      }}>{`Downloading and installing Node.js and npm`}</a>{`" and "`}<a parentName="p" {...{
        "href": "resolving-eacces-permissions-errors-when-installing-packages-globally"
      }}>{`Resolving EACCES permissions errors when installing packages globally`}</a>{`" for ways to avoid and resolve permissions errors.`}</p>
    <h2><inlineCode parentName="h2">{`Error: ENOENT, stat 'C:\\Users\\<user>\\AppData\\Roaming\\npm'`}</inlineCode>{` on Windows 7`}</h2>
    <p>{`The error `}<inlineCode parentName="p">{`Error: ENOENT, stat 'C:\\Users\\<user>\\AppData\\Roaming\\npm'`}</inlineCode>{` on Windows 7 is a consequence of `}<a parentName="p" {...{
        "href": "https://github.com/joyent/node/issues/8141"
      }}>{`joyent/node#8141`}</a>{`, and is an issue with the Node installer for Windows. The workaround is to ensure that `}<inlineCode parentName="p">{`C:\\Users\\<user>\\AppData\\Roaming\\npm`}</inlineCode>{` exists and is writable with your normal user account.`}</p>
    <h2>{`No space`}</h2>
    <pre><code parentName="pre" {...{}}>{`npm ERR! Error: ENOSPC, write
`}</code></pre>
    <p>{`You are trying to install on a drive that either has no space, or has no permission to write.`}</p>
    <ul>
      <li parentName="ul">{`Free some disk space or`}</li>
      <li parentName="ul">{`Set the tmp folder somewhere with more space: `}<inlineCode parentName="li">{`npm config set tmp /path/to/big/drive/tmp`}</inlineCode>{` or`}</li>
      <li parentName="ul">{`Build Node yourself and install it somewhere writable with lots of space.`}</li>
    </ul>
    <h2>{`No git`}</h2>
    <pre><code parentName="pre" {...{}}>{`npm ERR! not found: git
ENOGIT
`}</code></pre>
    <p>{`You need to `}<a parentName="p" {...{
        "href": "http://git-scm.com/book/en/Getting-Started-Installing-Git"
      }}>{`install git`}</a>{`. Or, you may need to add your git information to your npm profile. You can do this from the command line or the website. For more information, see "`}<a parentName="p" {...{
        "href": "managing-your-profile-settings"
      }}>{`Managing your profile settings`}</a>{`".`}</p>
    <h2>{`Running a Vagrant box on Windows fails due to path length issues`}</h2>
    <p><strong parentName="p"><a parentName="strong" {...{
          "href": "https://github.com/drmyersii"
        }}>{`@drmyersii`}</a></strong>{` went through what sounds like a lot of painful trial and error to come up with a working solution involving Windows long paths and some custom Vagrant configuration:`}</p>
    <blockquote>
      <p parentName="blockquote"><a parentName="p" {...{
          "href": "https://github.com/renobit/vagrant-node-env/commit/bdf15f2f301e2b1660b839875e34f172ea8be227"
        }}>{`This is the commit that I implemented it in`}</a>{`, but I'll go ahead and post the main snippet of code here:`}</p>
      <pre parentName="blockquote"><code parentName="pre" {...{
          "className": "language-ruby"
        }}>{`config.vm.provider "virtualbox" do |v|
    v.customize ["sharedfolder", "add", :id, "--name", "www", "--hostpath", (("//?/" + File.dirname(__FILE__) + "/www").gsub("/","\\\\"))]
end

config.vm.provision :shell, inline: "mkdir /home/vagrant/www"
config.vm.provision :shell, inline: "mount -t vboxsf -o uid=\`id -u vagrant\`,gid=\`getent group vagrant | cut -d: -f3\` > www /home/vagrant/www", run: "always"
`}</code></pre>
      <p parentName="blockquote">{`In the code above, I am appending `}<inlineCode parentName="p">{`\\\\?\\`}</inlineCode>{` to the current directory absolute path. This will actually force the Windows API to allow an increase in the MAX_PATH variable (normally capped at 260). Read more about `}<a parentName="p" {...{
          "href": "https://msdn.microsoft.com/en-us/library/windows/desktop/aa365247%28v=vs.85%29.aspx#maxpath"
        }}>{`max path`}</a>{`. This is happening during the sharedfolder creation which is intentionally handled by VBoxManage and not Vagrant's "synced_folder" method. The last bit is pretty self-explanatory; we create the new shared folder and then make sure it's mounted each time the machine is accessed or touched since Vagrant likes to reload its mounts/shared folders on each load.`}</p>
    </blockquote>
    <h2>{`npm only uses `}<inlineCode parentName="h2">{`git:`}</inlineCode>{` and `}<inlineCode parentName="h2">{`ssh+git:`}</inlineCode>{` URLs for GitHub repos, breaking proxies`}</h2>
    <p><strong parentName="p"><a parentName="strong" {...{
          "href": "https://github.com/LaurentGoderre"
        }}>{`@LaurentGoderre`}</a></strong>{` fixed this with `}<a parentName="p" {...{
        "href": "https://github.com/npm/npm/issues/5257#issuecomment-60441477"
      }}>{`some Git trickery`}</a>{`:`}</p>
    <blockquote>
      <p parentName="blockquote">{`I fixed this issue for several of my colleagues by running the following two commands:`}</p>
      <pre parentName="blockquote"><code parentName="pre" {...{}}>{`git config --global url."https://github.com/".insteadOf git@github.com:
git config --global url."https://".insteadOf git://
`}</code></pre>
      <p parentName="blockquote">{`One thing we noticed is that the `}<inlineCode parentName="p">{`.gitconfig`}</inlineCode>{` used is not always the one expected so if you are on a machine that modified the home path to a shared drive, you need to ensure that your `}<inlineCode parentName="p">{`.gitconfig`}</inlineCode>{` is the same on both your shared drive and in `}<inlineCode parentName="p">{`c:\\users\\[your user]\\`}</inlineCode></p>
    </blockquote>
    <h2>{`SSL Error`}</h2>
    <pre><code parentName="pre" {...{}}>{`npm ERR! Error: 7684:error:140770FC:SSL routines:SSL23_GET_SERVER_HELLO:unknown protocol:openssl\\ssl\\s23_clnt.c:787:
`}</code></pre>
    <p>{`You are trying to talk SSL to an unencrypted endpoint. More often than not, this is due to a `}<a parentName="p" {...{
        "href": "/misc/config#proxy"
      }}>{`proxy`}</a>{` `}<a parentName="p" {...{
        "href": "/misc/config#https-proxy"
      }}>{`configuration`}</a>{` `}<a parentName="p" {...{
        "href": "/misc/config#cafile"
      }}>{`error`}</a>{` (see also `}<a parentName="p" {...{
        "href": "http://jjasonclark.com/how-to-setup-node-behind-web-proxy"
      }}>{`this helpful, if dated, guide`}</a>{`). In this case, you do `}<strong parentName="p">{`not`}</strong>{` want to disable `}<inlineCode parentName="p">{`strict-ssl`}</inlineCode>{` – you may need to set up a CA / CA file for use with your proxy, but it's much better to take the time to figure that out than disabling SSL protection.`}</p>
    <pre><code parentName="pre" {...{}}>{`npm ERR! Error: SSL Error: CERT_UNTRUSTED
`}</code></pre>
    <pre><code parentName="pre" {...{}}>{`npm ERR! Error: SSL Error: UNABLE_TO_VERIFY_LEAF_SIGNATURE
`}</code></pre>
    <p>{`This problem will happen if you're running Node 0.6. Please upgrade to node 0.8 or above. `}<a parentName="p" {...{
        "href": "http://blog.npmjs.org/post/71267056460/fastly-manta-loggly-and-couchdb-attachments"
      }}>{`See this post for details`}</a>{`.`}</p>
    <p>{`You could also try these workarounds: `}<inlineCode parentName="p">{`npm config set ca ""`}</inlineCode>{` or `}<inlineCode parentName="p">{`npm config set strict-ssl false`}</inlineCode></p>
    <pre><code parentName="pre" {...{}}>{`npm ERR! Error: SSL Error: SELF_SIGNED_CERT_IN_CHAIN
`}</code></pre>
    <p><a parentName="p" {...{
        "href": "http://blog.npmjs.org/post/78085451721/npms-self-signed-certificate-is-no-more"
      }}>{`npm no longer supports its self-signed certificates`}</a></p>
    <p>{`Either:`}</p>
    <ul>
      <li parentName="ul">{`upgrade your version of npm `}<inlineCode parentName="li">{`npm install npm -g --ca=""`}</inlineCode></li>
      <li parentName="ul">{`tell your current version of npm to use known registrars `}<inlineCode parentName="li">{`npm config set ca=""`}</inlineCode></li>
    </ul>
    <p>{`If this does not fix the problem, then you may have an SSL-intercepting proxy.
(For example, `}<a parentName="p" {...{
        "href": "https://github.com/npm/npm/issues/7439#issuecomment-76024878"
      }}>{`https://github.com/npm/npm/issues/7439#issuecomment-76024878`}</a>{`)`}</p>
    <h2>{`SSL-intercepting proxy`}</h2>
    <p>{`Unsolved. See `}<a parentName="p" {...{
        "href": "https://github.com/npm/npm/issues/9282"
      }}>{`https://github.com/npm/npm/issues/9282`}</a></p>
    <h2>{`Not found / Server error`}</h2>
    <pre><code parentName="pre" {...{}}>{`npm http 404 https://registry.npmjs.org/faye-websocket/-/faye-websocket-0.7.0.tgz
npm ERR! fetch failed https://registry.npmjs.org/faye-websocket/-/faye-websocket-0.7.0.tgz
npm ERR! Error: 404 Not Found
`}</code></pre>
    <pre><code parentName="pre" {...{}}>{`npm http 500 https://registry.npmjs.org/phonegap
`}</code></pre>
    <ul>
      <li parentName="ul">{`It's most likely a temporary npm registry glitch. Check `}<a parentName="li" {...{
          "href": "http://status.npmjs.org/"
        }}>{`npm server status`}</a>{` and try again later.`}</li>
      <li parentName="ul">{`If the error persists, perhaps the published package is corrupt. Contact the package owner and have them publish a new version of the package.`}</li>
    </ul>
    <h2>{`Invalid JSON`}</h2>
    <pre><code parentName="pre" {...{}}>{`Error: Invalid JSON
`}</code></pre>
    <pre><code parentName="pre" {...{}}>{`npm ERR! SyntaxError: Unexpected token <
`}</code></pre>
    <pre><code parentName="pre" {...{}}>{`npm ERR! registry error parsing json
`}</code></pre>
    <ul>
      <li parentName="ul">{`Possible temporary npm registry glitch, or corrupted local server cache.
Run `}<inlineCode parentName="li">{`npm cache clean`}</inlineCode>{` and/or try again later.`}</li>
      <li parentName="ul">{`This can be caused by corporate proxies that give HTML
responses to `}<inlineCode parentName="li">{`package.json`}</inlineCode>{` requests. Check npm's proxy `}<a parentName="li" {...{
          "href": "/misc/config"
        }}>{`configuration`}</a>{`.`}</li>
      <li parentName="ul">{`Check that it's not a problem with a package you're trying to install
(e.g. invalid `}<inlineCode parentName="li">{`package.json`}</inlineCode>{`).`}</li>
    </ul>
    <h2>{`Many `}<inlineCode parentName="h2">{`ENOENT`}</inlineCode>{` / `}<inlineCode parentName="h2">{`ENOTEMPTY`}</inlineCode>{` errors in output`}</h2>
    <p>{`npm is written to use resources efficiently on install, and part of this is that it tries to do as many things concurrently as is practical. Sometimes this results in race conditions and other synchronization issues. As of npm 2.0.0, a very large number of these issues were addressed. If you see `}<inlineCode parentName="p">{`ENOENT lstat`}</inlineCode>{`, `}<inlineCode parentName="p">{`ENOENT chmod`}</inlineCode>{`, `}<inlineCode parentName="p">{`ENOTEMPTY unlink`}</inlineCode>{`, or something similar in your log output, try updating npm to the latest version. If the problem persists, look at `}<a parentName="p" {...{
        "href": "https://github.com/npm/npm/issues/6043"
      }}>{`npm/npm#6043`}</a>{` and see if somebody has already discussed your issue.`}</p>
    <h2><inlineCode parentName="h2">{`cb() never called!`}</inlineCode>{` when using shrinkwrapped dependencies`}</h2>
    <p>{`Take a look at `}<a parentName="p" {...{
        "href": "https://github.com/npm/npm/issues/5920"
      }}>{`issue #5920`}</a>{`. `}<del parentName="p">{`We're working on fixing this one, but it's a fairly subtle race condition and it's taking us a little time. You might try moving your `}<inlineCode parentName="del">{`npm-shrinkwrap.json`}</inlineCode>{` file out of the way until we have this fixed.`}</del>{` This has been fixed in versions of npm newer than `}<inlineCode parentName="p">{`npm@2.1.5`}</inlineCode>{`, so update to `}<inlineCode parentName="p">{`npm@latest`}</inlineCode>{`.`}</p>
    <h2><inlineCode parentName="h2">{`npm login`}</inlineCode>{` errors`}</h2>
    <p>{`Sometimes `}<inlineCode parentName="p">{`npm login`}</inlineCode>{` fails for no obvious reason.  The first thing to do is to log in at `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/login"
      }}>{`https://www.npmjs.com/login`}</a>{` and check that your e-mail address on `}<inlineCode parentName="p">{`npmjs.com`}</inlineCode>{` matches the
email address you are giving to `}<inlineCode parentName="p">{`npm login`}</inlineCode>{`.`}</p>
    <p>{`If that's not the problem, or if you are seeing the message `}<inlineCode parentName="p">{`"may not mix password_sha and pbkdf2"`}</inlineCode>{`, then`}</p>
    <ol>
      <li parentName="ol">{`Log in at `}<a parentName="li" {...{
          "href": "https://npmjs.com/"
        }}>{`https://npmjs.com/`}</a></li>
      <li parentName="ol">{`Change password at `}<a parentName="li" {...{
          "href": "https://npmjs.com/password"
        }}>{`https://npmjs.com/password`}</a>{` – you can even "change" it to the same password`}</li>
      <li parentName="ol">{`Clear login-related fields from `}<inlineCode parentName="li">{`~/.npmrc`}</inlineCode>{` – e.g., by running `}<inlineCode parentName="li">{`sed -ie '/registry.npmjs.org/d' ~/.npmrc`}</inlineCode></li>
      <li parentName="ol"><inlineCode parentName="li">{`npm login`}</inlineCode></li>
    </ol>
    <p>{`and it generally seems to work.`}</p>
    <p>{`See `}<a parentName="p" {...{
        "href": "https://github.com/npm/npm/issues/6641#issuecomment-72984009"
      }}>{`https://github.com/npm/npm/issues/6641#issuecomment-72984009`}</a>{` for the history of this issue.`}</p>
    <h2><inlineCode parentName="h2">{`npm`}</inlineCode>{` hangs on Windows at `}<inlineCode parentName="h2">{`addRemoteTarball`}</inlineCode></h2>
    <p>{`Check if you have two temp directories set in your `}<inlineCode parentName="p">{`.npmrc`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{}}>{`> npm config ls -l
`}</code></pre>
    <p>{`Look for lines defining the `}<inlineCode parentName="p">{`tmp`}</inlineCode>{` config variable.  If you find more than one, remove all but one of them.`}</p>
    <p>{`See `}<a parentName="p" {...{
        "href": "https://github.com/npm/npm/issues/7590"
      }}>{`https://github.com/npm/npm/issues/7590`}</a>{` for more about this unusual problem.`}</p>
    <h2>{`npm not running the latest version on a Windows machine`}</h2>
    <p>{`See the section about Windows `}<a parentName="p" {...{
        "href": "try-the-latest-stable-version-of-npm"
      }}>{`here`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      